{
  "concepts": {
    "infrastructure": {
      "label": "Infrastructure as a service",
      "description": "Infrastructure-related services and costs"
    },
    "licenses": {
      "label": "Licenses / Software as a service",
      "description": "Software or usage licenses"
    },
    "service": {
      "label": "Professional services",
      "description": "Professional or operational services"
    },
    "support": {
      "label": "Support services",
      "description": "Support and maintenance services"
    }
  },
  "header": {
    "title": "PangeX",
    "item": {
      "home": "Home",
      "web": "AlsoThere",
      "faq": "FAQ",
      "contact": "Contact"
    }
  },
  "screens": {
    "explore": {
      "title": "Explore",
      "subtitle": "This app includes example code to help you get started.",
      "sections": {
        "routing": "File-based routing",
        "platform": "Android, iOS, and web support",
        "images": "Images",
        "theme": "Light and dark mode components",
        "animations": "Animations"
      }
    },
    "home": {
      "title": "Home",
      "welcomeMessage": "Welcome to the app!"
    },
    "benchmarking": {
      "title": "Global Benchmarking",
      "subtitle": "Test one expansion model across multiple markets to find the best outcome.",
      "description": "These inputs will be common to all scenarios and will serve as the baseline for your benchmark. In the next step, you will be able to create distinct scenarios to compare them against each other.",
      "empty": {
        "title": "There are no results",
        "description": "Complete the form to see the results"
      },
      "addScenario": "Add scenario",
      "scenario": "Scenario"
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "questions": {
        "q1": {
          "question": "What is AlsoThere?",
          "answer": "AlsoThere is <strong>the best transactional infrastructure platform</strong> and the <strong>most cost-effective solution</strong> for the global expansion of B2B, SaaS, and professional services companies in general. It works as an “On-Demand Subsidiary,” where your company sells its services, delivers the service, and maintains the business relationship with the end customer, while AlsoThere takes care of closing the entire cycle of an international B2B transaction, signing contracts, issuing local invoices, collecting payments in local currency, and ensuring compliance with tax regulations in any of the 43 countries where we operate; without the need to establish physical offices or legal entities, turning a high-risk expansion (CAPEX) into a predictable operating expense (OPEX)."
        },
        "q2": {
          "question": "What is the “Subsidiary On-Demand” model?",
          "answer": "A Subsidiary On-Demand utilizes the corporate, financial, and legal infrastructure of eSource Capital Group. It allows your company to do business in a foreign market without establishing a physical presence or permanent legal entity. Unlike a traditional subsidiary, which requires a significant investment of time, cost, and administrative effort to establish and maintain, our service allows you to submit local proposals, sign local contracts, invoice locally, facilitate collection in local currency, and maintain control of your customer relationships."
        },
        "q3": {
          "question": "How does AlsoThere and its Subsidiary on-Demand model help my company?",
          "answer": "<ul><li><strong>From CAPEX to OPEX (Up to 10X more profitable):</strong> Transform the high-risk initial investment (CAPEX) required by a traditional subsidiary, which usually takes 6 to 12 months, into an agile and predictable operating expense (OPEX).</li> <li><strong>Speed to Lead:</strong> Being operational in days, you can accelerate your revenue and instantly capitalize on your early adopters in multiple markets simultaneously, while obtaining real data on the behavior of each market, helping you make better decisions.</li><li> <strong>Total Customer Control:</strong> Unlike traditional reseller models that hijack your business relationship, we act solely as your transactional infrastructure so you retain 100% control of your customers and margins.</li><li> <strong>Full Regulatory Compliance:</strong> We act as your authorized agent to ensure compliance with local laws, facilitating financial consolidation and collection in up to 14 different currencies.</li></ul> <strong>Our Backing:</strong> Driven by eSource Capital Group's more than 20 years of experience in cross-border regulations, we have securely processed over US$250 million in billings on behalf of corporate clients worldwide."
        },
        "q4": {
          "question": "How does the international expansion calculator/simulator work and what scenarios can I compare?",
          "answer": "The PangeX Calculator/Simulator uses real data based on tax regulations between the selected countries and the values of the scenarios you want to simulate. It provides you with both a comparison of the different business models under which you can expand into a country (Model Comparison) and a comparison of how the same expansion model would vary in different countries (Global BenchMark)."
        },
        "q5": {
          "question": "Which expansion scenarios can I compare?",
          "answer": "The tool automatically compares <strong> four main international expansion models</strong>:<ol><li><strong>Direct International Billing</strong> (from one of your countries where you have a legal entity).</li><li>Use of a <strong>Local Partner.</strong></li><li>Opening Your <strong>Own Subsidiary.</strong></li><li>The <strong>AlsoThere</strong> model.</li></ol>"
        },
        "q6": {
          "question": "Why is a local invoice better for my client than an international one?",
          "answer": "Issuing a local invoice is the best strategy for eliminating purchasing barriers. It is beneficial to your customer for these main reasons:<ul><li><strong>Deductibility and Direct Savings:</strong> Local tax laws (such as SAT in Mexico, AFIP in Argentina, or DIAN in Colombia) require a valid local receipt for an expense to be deductible. This allows your customer to reduce their income tax base and credit local VAT, resulting in a financial recovery.</li><li><strong>Elimination of Cost Overruns (Competitiveness):</strong> When issuing an international invoice, the regulations in your country of origin may require you to include your own VAT. Since your customer abroad cannot deduct or credit a tax from another country, this directly increases the final cost of the service for them, causing you to lose competitiveness against local suppliers.</li><li><strong>Risk Mitigation and Penalties:</strong> Unlike an international invoice, which lacks tax validity in the destination country, a local invoice guarantees full compliance with form and substance regulations. This protects the customer from potential audits, fines, or penalties resulting from incorrect expense justification.</li><li><strong>Simplified Payment Processes:</strong> Eliminates financial complications by allowing the customer to pay in their own local currency (avoiding exchange rate fluctuations) and through their traditional systems.</li><li><strong>Unlocking Corporate Accounts (Enterprise-ready):</strong> Many large corporations have strict policies that legally prohibit them from making payments to foreign entities if they do not receive a local invoice. Invoicing locally gives you immediate access to this level of customers.</li><li><strong>Credibility and trust in the market:</strong> Operating under local laws and regulations conveys transparency, stability, and a long-term commitment that a remote foreign company cannot match.</li></ul>"
        },
        "q7": {
          "question": "What type of companies is this solution designed for?",
          "answer": "AlsoThere is optimized for <strong>knowledge-based service companies of any size.</strong> It is the ideal solution for:<ul><li>Software as a Service (SaaS) providers and ISVs.</li><li>Digital and marketing agencies.</li><li>Consulting firms and professional service exporters.</li><li>Companies with international clients or focused on cross-border sales.</li></ul> On the other hand, AlsoThere does not provide its services for sales to government entities, or companies that wish to sell physical products that require import and export logistics, nor does it get involved in hiring personnel or payroll."
        },
        "q8": {
          "question": "Does AlsoThere assist with hiring staff or managing payroll?",
          "answer": "<p>AlsoThere does not offer direct human resources, payroll, or employer of record (EoR) services. This model specializes exclusively in being a <strong>transactional and commercial layer</strong> that handles contracts, invoicing, collections, and tax compliance.</p><p>Since the goal is to expand internationally while minimizing financial risks and moving from a CAPEX to OPEX model, here is a 4-step framework for scaling talent when providing services in new countries:</p><ol><li><strong>Start lean:</strong> Manage initial sales with your current resources or hire additional talent only in countries where you already have an established legal entity.</li><li><strong>On-demand support:</strong> When you reach the point where you need part-time account management or a first-level help desk in new markets, AlsoThere offers these services directly under the Subsidiary On-Demand model.</li><li><strong>Local hiring:</strong>Once you reach a critical mass of business and require dedicated local talent, you can hire them hassle-free through global employment services such as Remote, Globalization Partners, or Adecco, among others.</li><li><strong>Strategic physical expansion:</strong> Finally, when you achieve solid cash flow, validate positive growth, and are aligned with strategic objectives, you can confidently consider opening a new legal entity in that specific country and establishing a local team.</li></ol>"
        },
        "q9": {
          "question": "Will I retain control of my customers if I use AlsoThere?",
          "answer": "<strong>Yes, you will retain 100% control of your customers.</strong> Unlike traditional resellers who hijack the relationship with the end user, AlsoThere acts solely as your support infrastructure (an operational “plug-in”). You retain complete control over sales, customer relations, the business cycle, and pricing."
        },
        "q10": {
          "question": "How quickly can I start invoicing in a new country?",
          "answer": "<p>With AlsoThere, your company will be ready to operate, sign contracts, and issue local invoices legally in as little as <strong>48 hours<strong>, once your end customer has completed the supplier registration process.</p>"
        },
        "q11": {
          "question": "What does the calculator allow me to simulate?",
          "answer": "<p>PangeX allows you to project the export of your services to various global markets. The tool generates net <strong>income estimates</strong> using two strategic approaches:</p><ul><li><strong>Model Comparison:</strong> Evaluate the financial impact of different export schemes within the same country to identify the most profitable route.</li><li><strong>Global Benchmark:</strong> Compare how the same expansion model performs in different countries, making it easier to prioritize markets based on profitability.</li></ul>"
        },
        "q12": {
          "question": "Are the calculator results accurate?",
          "answer": "<p>The calculator results should be considered an estimated projection, not exact results. Key factors that determine why final values may vary:</p><p><strong>Variability Factors</p></strong><ul><li><strong>Market Fluctuations: </strong>Estimated values may change based on market conditions and other external factors that occur between the time of calculation and the actual transaction.</li><li><strong>Dynamic Exchange Rate: </strong>Although the exchange rate on the day of the simulation is used for the scenario simulation, the exchange rate in effect at the time of each transaction (both when collecting from the customer and paying the supplier) will be applied in the actual execution.</li><li><strong>Official Source:</strong> Exchange rates are governed by the official sources of the central banks (or equivalents) of the countries involved.</li></ul><p><strong>Currency Reference</p></strong><ul><li>To maintain consistency in the simulation of different scenarios, we use the US dollar (USD) as the reference currency for the final payment. However, it is important to remember that payments in the destination country will be made in the local currency.</li></ul>"
        },
        "q13": {
          "question": "How much does it cost to open a traditional subsidiary compared to AlsoThere?",
          "answer": "<p>AlsoThere is the <strong>best solution</strong> for your global expansion, being up to <strong>10 times more cost-effective </strong>than a traditional setup. While the classic model requires high and risky capital expenditures (CAPEX), AlsoThere transforms your market entry into a predictable and recurring operating expense (OPEX), <strong>completely eliminating infrastructure costs.</strong></p><p>To understand the financial impact, here is a direct comparison of both models:</p><ul><li><strong>Traditional Subsidiary:</strong> Takes 5 to 10 months to be ready for operation. Requires an initial investment of between <strong>$7,500 and $38,000 USD</strong>, exclusively for legal and accounting setup. Added to this are minimum monthly operating costs ranging from <strong>$3,500 to $11,000</strong> per country, solely for local administrative and billing management, without considering the expenses associated with customer acquisition.</li><li><strong>The AlsoThere alternative: There is no initial cost</strong> to access our service, platform, and global network. Under the 'On-Demand Subsidiary' model, <strong>you only pay when you have used our services.</strong> We only charge you after we receive payment from your end customer and process the payment to the corresponding supplier. This cost is structured through a fee per invoice, the percentage of which will depend specifically on the amount, frequency, and total amount to be invoiced annually in each country.<p>As the leading platform in the market for B2B internationalization, AlsoThere adapts to your company's operational needs to help you accelerate your growth. We always seek to offer you the most competitive option, so that with us you receive the best Net Revenue and can start selling in 48 hours without assuming the financial risks of the old school.</p></li></ul>"
        },
        "q14": {
          "question": "What risks does the AlsoThere model mitigate?",
          "answer": "As the <strong>best strategic solution</strong> for global expansion, AlsoThere's “On-Demand Subsidiary” model provides comprehensive protection against the biggest risks of internationalization, including:<ul><li><strong>Financial risk and the “right to choose the wrong country”:</strong> By eliminating the need to invest in high infrastructure costs (CAPEX) and turning your market entry into a flexible operating expense (OPEX), the model gives you the <strong>valuable right to choose the wrong country.</strong> It prevents you from spending capital prematurely in the wrong market, mitigating the risky “all or nothing” gamble. If you test a market and demand is not as expected, you can simply iterate and move on to the next territory without having wasted months of time and tens of thousands of dollars on opening and closing legal entities.</li><li><strong>Legal and tax compliance risks:</strong> As your <strong>primary transactional infrastructure</strong>, AlsoThere assumes and manages regulatory complexity. This prevents fines, disputes, or penalties for ignorance of other countries' tax laws, ensuring full regulatory compliance (Compliance-as-a-Service) so you can operate with peace of mind.</li><li><strong>Currency exchange risks:</strong> Significantly reduce your exposure to foreign currency volatility. The platform allows you to invoice directly in local currency and manage payment consolidations in multiple currencies (up to 14 currencies) in a centralized and secure manner.</li><li><strong>Opportunity risk (Time-to-Market):</strong> Eliminate the risk of losing your early adopters (pioneering customers) due to bureaucratic delays. By being legally and commercially operational in 48 hours instead of waiting 6 to 12 months, you immediately capitalize on existing demand and close deals before your competition can react.</li></ul>"
        },
        "q15": {
          "question": "What taxes and costs does expansion involve (and what do I need to receive payments)?",
          "answer": "<p>To ensure you have the <strong>best transactional infrastructure</strong> for your global expansion, the payment receipt flow with AlsoThere is designed to be agile, secure, and 100% compliant. To start receiving your payments, the step-by-step process is as follows: you sign a <strong>Master Agreement</strong> with us, send your customer a quote using that already includes the terms of service, and the local customer signs a service agreement explicitly authorizing us to bill and collect on your behalf.</p><p>Once AlsoThere's local subsidiary issues the invoice and successfully collects the money, it transfers the funds directly to your bank account according to the agreed payment schedule, deducting only the following items:</p><ul><li><strong>Applicable taxes: Local jurisdiction taxes and withholding tax (WHT)</strong> are taken into account. It is important to note that <strong>this WHT is exactly the same as that applied when you invoice internationally directly.</strong></li><li><strong>Operating costs and fees:</strong> Previously agreed operating fees and charges (the transaction fee) are deducted. All of this falls under a <strong>predictable operating expense (OPEX)</strong>, ensuring that you do not incur hidden maintenance costs and maximizing the profitability of your expansion.</li></ul><p>As the <strong>best transactional infrastructure</strong>, this simplified scheme allows you to operate immediately, delegating all financial and regulatory complexity without overwhelming operational details.</p>"
        }
      }
    }
  },
  "home": {
    "hero": {
      "title": "Find the Most Profitable Path for Your Global Expansion",
      "subtitle": "Stop guessing your international costs. Use PangeX to compare: International invoicing,  traditional subsidiaries, local partners, and the Subsidiary on-Demand model using current Withholding Tax policies and estimated operating costs. Find the exact strategy that maximizes your Net Revenue.",
      "cta": "Simulate",
      "comparison": {
        "title": "PangeX Model Comparison",
        "description": "Find the most profitable infrastructure for your target market."
      },
      "benchmarking": {
        "title": "PangeX Global Benchmark",
        "description": "Validate one business model across multiple countries."
      }
    },
    "features": {
      "earnings": {
        "title": "Estimated International Earnings",
        "description": "Stop guessing your global margins. PangeX uses real-time tax regulations, official exchange rates, and WHT data to accurately project your net revenue"
      },
      "enablement": {
        "title": "Global Expansion Enablement",
        "description": "PangeX helps tech and knowledge-based-service firms find their most profitable path into 43 countries across the US, EU, and LATAM"
      },
      "results": {
        "title": "Immediate Results",
        "description": "PangeX compares the main expansion models. Make data-driven decisions to mitigate financial risks and accelerate your speed-to-revenue"
      }
    },
    "scenarios": {
      "header": "System Scenarios",
      "loading": "Loading pair data…",
      "error": "Error loading data",
      "notFound": "Pair not found in Firestore for {{customer}}_{{vendor}}.",
      "resultsTitle": "PangeX Model Comparison Results",
      "resultsBadge": "SIMULATION COMPLETED",
      "resultsSubtitle": "Based on real-time tax regulations and dynamic exchange rates from official central banks, we have benchmarked your projected Net Revenue across the main models of international expansion.",
      "resultsDescription": "Instead of generic pros and cons, we provide you with data-backed financial insights to evaluate the cost of your market entry and risk assessment."
    },
    "reportForm": {
      "title": "Get your detailed Report",
      "description": "Enter your information to receive a email with the results of the simulation.",
      "nameLabel": "Full Name",
      "namePlaceholder": "Your name",
      "emailLabel": "Email Address",
      "emailPlaceholder": "your@email.com",
      "submitButton": "Get Report",
      "success": "Report sent successfully! Check your email.",
      "error": "There was an error sending the report. Please try again."
    },
    "compare": {
      "cta": {
        "schedule": {
          "title": "Schedule a Meeting",
          "description": "Speak with one of our experts for a personalized assessment.",
          "button": "Schedule"
        },
        "scheduleAlsoThere": {
          "title": "A more favorable Projected Net revenue has been found with AlsoThere",
          "description": "Schedule a free meeting to learn more.",
          "button": "Schedule"
        },
        "alsoThere": {
          "title": "Also There",
          "description": "Learn more about how we can help you scale.",
          "button": "More Info"
        }
      }
    }
  },
  "scenarios": {
    "types": {
      "localPartner": {
        "title": "Local Partner",
        "subtitle": "Sell through a local partner (margin applied)",
        "resume": {
          "risk": "Overall Risk",
          "competitiveness": "Overall Competitiveness",
          "items": {
            "first": "Third dependency",
            "second": "Shared margin",
            "third": "Local knowledge"
          }
        }
      },
      "internationalInvoicing": {
        "title": "International Invoicing",
        "subtitle": "Invoice internationally (no local entity)",
        "resume": {
          "risk": "Overall Risk",
          "competitiveness": "Overall Competitiveness",
          "items": {
            "first": "Permanent establishment risk",
            "second": "No local legal support",
            "third": "Low initial cost"
          }
        }
      },
      "localSubsidiary": {
        "title": "Local Subsidiary",
        "subtitle": "Operate via a local subsidiary",
        "resume": {
          "risk": "Overall Risk",
          "competitiveness": "Overall Competitiveness",
          "items": {
            "first": "High setup costs",
            "second": "Administrative bureaucracy",
            "third": "Total control"
          }
        }
      },
      "alsoThere": {
        "title": "AlsoThere",
        "subtitle": "Use AlsoThere to handle cross-border payments",
        "resume": {
          "risk": "Overall Risk",
          "competitiveness": "Overall Competitiveness",
          "items": {
            "first": "Legal compliance guaranteed",
            "second": "No legal entity required",
            "third": "HR and payroll management included",
            "fourth": "Single monthly fee"
          }
        }
      }
    },
    "card": {
      "customerCountry": "Customer Country",
      "vendorCountry": "Vendor Country (Payment Destiny)",
      "concept": "Concept",
      "invoicingAmount": "Invoicing Amount",
      "localInvoicingDetails": "Local Invoicing Details",
      "exchangeRate": "Exchange Rate",
      "invoiceAmountLocal": "Estimated end customer sales",
      "localVat": "Local VAT ({{rate}})",
      "estimatedLocalInvoice": "Estimated local invoice amount to end customer",
      "results": "Results",
      "operationalCosts": "Country Estimated Additional Operational Costs (Unrecoverable taxes) ({{rate}})",
      "wht": "Country Estimated Withholding Tax ({{rate}})",
      "transactionCost": "Cost of transaction",
      "sharedMargin": "Shared Marging With Local Partner ({{rate}})",
      "financialStructure": "Average monthly cost of financial structure",
      "indirectCosts": {
        "label": "Indirect cost to the client",
        "value": "Not tax deductible."
      },
      "estimatedPayment": "Projected Net Revenue",
      "estimatedPaymentUSD": "Projected Net Revenue USD",
      "invoicing": "Invoicing",
      "costs": "Costs",
      "netRevenueExclusions": "Net Revenue Exclusions",
      "localVatTooltip": "Local VAT generates a tax credit for the final customer, does not increase the cost for the customer, nor does it impact their net revenue.",
      "netRevenueExclusionsTooltip": "Means Taxes and any other withholding required by applicable Law.",
      "setupAndOperationalCosts": {
        "title": "Setup & Operational Costs",
        "tooltip": "Combines initial investment and recurring expenses needed to operate legally in a new market. The financial impact varies depending on the expansion model.",
        "value": {
          "localPartner": "Implies variable costs for the search, negotiation and management of the commercial alliance.",
          "internationalInvoicing": "No setup costs. Invoiced directly in USD from the country of origin.",
          "localSubsidiary": "It is the most expensive model, as it requires creating and maintaining a permanent legal and operational infrastructure in the destination country.",
          "alsoThere": ""
        },
        "items": {
          "setupCost": "Setup Cost",
          "operationalCost": "Monthly Operational Cost"
        }
      },
      "scability": {
        "title": "Scalability",
        "tooltip": "Evaluate the ability to grow quickly in new markets, projecting local confidence and maintaining control of your expansion.",
        "value": {
          "localPartner": "Requires a local partner in each country to use their infrastructure.",
          "internationalInvoicing": "You are perceived as foreign and there is tax/foreign exchange complexity for the client.",
          "localSubsidiary": "Takes 5 to 10 months per country, growth is rigid, and there is high capital risk.",
          "alsoThere": ""
        },
        "items": {
          "presence": "Robust Corporate Presence From Day One",
          "scalability": "Controlled International Scalability"
        }
      },
      "timeToMarket": {
        "title": "Time to Market",
        "tooltip": "Measures the time it takes to be able to sell, sign contracts and invoice legally in a new country.",
        "value": {
          "localPartner": "3 to 7 months of search and negotiation of the agreement.",
          "internationalInvoicing": "Immediate, but generates a tax burden for the client and is usually rejected by corporate clients.",
          "localSubsidiary": "5 to 11 months of legal paperwork and accounting setup.",
          "alsoThere": ""
        }
      },
      "transactionalAndPaymentCapabilities": {
        "title": "Transactional & Payment Capabilities",
        "tooltip": "Measures the ability to eliminate financial barriers, adapting to the client's fiscal and operational needs.",
        "value": {
          "localPartner": "",
          "internationalInvoicing": "Increases indirect costs for the client, since the invoice is not tax deductible in their country. It also limits payment in local currency.",
          "localSubsidiary": "",
          "alsoThere": ""
        },
        "items": {
          "localInvoicingBenefits": "Local Invoicing Benefit for end customer",
          "localCurrencyPayments": "end customer payment in local currency",
          "consolidation": "Multi-Country Payment Consolidation"
        }
      },
      "customerRelationship": {
        "title": "Customer Relationship Management",
        "tooltip": "Measures your ability to formalize business locally without sacrificing control over your accounts.",
        "value": {
          "localPartner": "The intermediary controls the relationship and lowers your margin.",
          "internationalInvoicing": "Use foreign laws.",
          "localSubsidiary": "",
          "alsoThere": ""
        },
        "items": {
          "localizedContacts": "Localized Contracts with Customers",
          "clientRelationship": "Retain Full Control Over Client Relationships"
        }
      },
      "businessAutonomy": {
        "title": "Business Autonomy & Revenue",
        "tooltip": "Measures your ability to operate internationally without losing commercial control or giving up your profit margins.",
        "value": {
          "localPartner": "The intermediary cuts your trading margin and you depend on their rules and priorities.",
          "internationalInvoicing": "",
          "localSubsidiary": "",
          "alsoThere": ""
        },
        "items": {
          "operationalIndependence": "Operational Independence",
          "retainControl": "Retain Control on Profits"
        }
      },
      "compliance": {
        "title": "Compliance with Local Fiscal Regulations",
        "tooltip": "Measures your ability to operate in strict compliance with the tax laws of the destination country, protecting both parties from fines or legal problems.",
        "value": {
          "localPartner": "",
          "internationalInvoicing": "International invoicing often creates hidden financial and administrative burdens for clients, prompting them to demand tax-compliant local invoices.",
          "localSubsidiary": "",
          "alsoThere": ""
        }
      }
    },
    "actions": {
      "manage": "Manage scenarios",
      "select": "Select scenarios"
    },
    "resultsBadge": {
      "risk": "Measure your level of financial, commercial, and legal exposure when entering a new country.",
      "competitiveness": "Measure your ability to sell abroad with the same strength, ease, and confidence as a local company."
    }
  },
  "onboarding": {
    "title": "PangeX Model Comparison",
    "subtitle": "Find the Most Profitable Path for Your Global Expansion. Stop guessing your international costs",
    "description": "We help you understand scenarios, costs, and opportunities before taking the next step",
    "sections": {
      "marketScope": "Market Scope",
      "financialParameters": "Financial Parameters",
      "businessIndustry": "Business & Industry",
      "selectScenarios": "Select scenarios"
    },
    "steps": {
      "pair": {
        "title": "Export markets",
        "subtitle": "Set your export route"
      },
      "commercial": {
        "title": "Commercial setup",
        "subtitle": "How is the deal structured?"
      },
      "invoicing": {
        "title": "Invoicing",
        "subtitle": "Amount and currency details"
      },
      "review": {
        "title": "Review",
        "subtitle": "Confirm and run scenario analysis"
      }
    },
    "actions": {
      "next": "Next",
      "back": "Back",
      "clear": "Clear",
      "cancel": "Cancel",
      "run": "Run analysis",
      "edit": "Edit",
      "continue": "Continue to the simulation"
    },
    "fields": {
      "vendorCountryListTooltip": "Current locations with operating subsidiaries; the countries where your company has legal entities",
      "vendorCountryList": "Select Established Markets",
      "vendorCountryTooltip": "Country that will receive the projected net revenue. The source country that issues the international invoice to the customer",
      "vendorCountry": "Select Revenue Recognition Country",
      "customerCountryTooltip": "The new country where you plan to sell. Currently with no operating subsidiaries (Legal entity)",
      "customerCountry": "Select Expansion Country",
      "searchPlaceholder": "Select an expansion country",
      "invoicingConcept": "Select the service category to invoice",
      "invoicingConceptTooltip": "Type of deliverable to be billed to the final customer in the new market",
      "currencyQuestion": "What is the estimated budget and in what currency?",
      "localPartnerQuestion": "Enable Local Partner Scenario",
      "partnerMargin": "Select the margin to be allocated to a local partner",
      "partnerMarginPlaceholder": "e.g., 45",
      "partnerMarginDescription": "Enter the percentage margin your local partner takes from the deal.",
      "invoicingAmount": "Estimated monthly end customer sales",
      "invoicingAmountDescription": "Projected amount to be invoiced to end customers",
      "invoicingAmountPlaceholder": "e.g., 50.000",
      "selectScenarios": "Select export channels",
      "selectScenariosTooltip": "Select the export channels you want to compare",
      "scenario": "Expansion Scenario",
      "scenarioTooltip": "International invoicing (direct exports without a physical presence), a local partner (invoicing through a local partner to simplify operational burdens), or establishing a local subsidiary (a company owned by the business to operate and issue invoices with full control in the target market).",
      "errors": {
        "selectOrigin": "Select at least one country",
        "selectDestination": "Select a country",
        "validAmount": "Enter a valid amount",
        "validMargin": "Enter a valid margin",
        "selectAtLeastOneScenario": "Select at least one scenario",
        "invoicingConcept": "Select a Business or Industry",
        "differentOriginDestination": "Origin and destination must be different",
        "partnerMarginRequired": "Partner margin is required"
      }
    },
    "warnings": {
      "exchangeControl": "This country is not available and cannot be used for scenario analysis or benchmarking"
    },
    "review": {
      "title": "Review your inputs",
      "pair": "Pair",
      "concept": "Concept",
      "pricing": "Pricing",
      "localPartner": "Local partner",
      "amount": "Amount",
      "currency": "Currency"
    },
    "summary": {
      "title": "Modeling Inputs",
      "vendorCountryList": "Established markets",
      "vendorDestination": "Revenue Recognition Countries",
      "customerOrigin": "Expansion Country",
      "invoicingAmount": "Estimated monthly end customer sales",
      "invoicingConcept": "Service Category to Invoice",
      "localInvoicingDetails": "Local Invoicing Details",
      "localPartnerMargin": "Local Partner Margin",
      "margin": "Margin"
    },
    "commonSectionHint": "These inputs are common to all scenarios and will serve as the baseline for your benchmark. In the next step, you will be able to create distinct scenarios to compare them against each other."
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "search": "Search...",
    "noMatches": "No matches",
    "selectAll": "Select all",
    "select": "Select...",
    "cancel": "Cancel",
    "loading": "Loading...",
    "sending": "Sending...",
    "save": "Save changes",
    "step": "Step",
    "of": "Of",
    "user": "User",
    "logoAlt": "PangeX Logo",
    "iconAlt": "PangeX Icon",
    "backgroundAlt": "Abstract decorative background",
    "underConstruction": {
      "title": "Under Construction",
      "description": "We are working hard to bring you this feature soon. Stay tuned!"
    },
    "levels": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "edit": "Edit",
    "reset": "Reset"
  },
  "footer": {
    "tagline": "\"PangeX\" originates from \"Pangea,\" implying the reunification of territories, the elimination of borders, and the consolidation of markets.",
    "privacy": "Privacy",
    "terms": "Terms",
    "sitemap": "Sitemap",
    "rights": "© {{year}} PangeX. All rights reserved.",
    "contact": "Contact Info"
  },
  "cta": {
    "schedule": {
      "title": "Schedule a free scenario analysis",
      "description": "Speak with one of our experts to discuss your case in more detail.",
      "button": "Schedule"
    },
    "contact": {
      "title": "Contact us",
      "description": "Learn more about how we can help you scale your business.",
      "comment": "Help us make this tool more useful, send us your suggestions.",
      "button": "Contact"
    }
  },
  "countries": {
    "br": "Brazil",
    "ar": "Argentina",
    "bo": "Bolivia",
    "cl": "Chile",
    "co": "Colombia",
    "cr": "Costa Rica",
    "ec": "Ecuador",
    "sv": "El Salvador",
    "gt": "Guatemala",
    "hn": "Honduras",
    "mx": "Mexico",
    "ni": "Nicaragua",
    "pa": "Panama",
    "py": "Paraguay",
    "pe": "Peru",
    "do": "Dominican Republic",
    "de": "Germany",
    "at": "Austria",
    "be": "Belgium",
    "bg": "Bulgaria",
    "cy": "Cyprus",
    "hr": "Croatia",
    "dk": "Denmark",
    "sk": "Slovakia",
    "si": "Slovenia",
    "es": "Spain",
    "ee": "Estonia",
    "fi": "Finland",
    "fr": "France",
    "gr": "Greece",
    "hu": "Hungary",
    "ie": "Ireland",
    "it": "Italy",
    "lv": "Latvia",
    "lt": "Lithuania",
    "lu": "Luxembourg",
    "mt": "Malta",
    "nl": "Netherlands",
    "pl": "Poland",
    "pt": "Portugal",
    "cz": "Czech Republic",
    "ro": "Romania",
    "se": "Sweden",
    "us": "United States",
    "uy": "Uruguay",
    "ve": "Venezuela",
    "gb": "United Kingdom",
    "ca": "Canada",
    "in": "India",
    "ch": "Switzerland",
    "no": "Norway",
    "sg": "Singapore"
  },
  "report": {
    "compare": {
      "title": "Your international expansion scenarios",
      "description": "Compare the financial impact of each model",
      "table": {
        "headers": {
          "advantages": "Competitive Advantages",
          "internationalInvoicing": "International Invoicing",
          "localPartner": "Use Local Partner",
          "localSubsidiary": "Establish Own Subsidiary",
          "alsoThere": "AlsoThere"
        },
        "rows": {
          "row1": "Localized contracts with customers",
          "row2": "Local invoicing",
          "row3": "Tax-deductible invoice for the Client",
          "row4": "Compliance with local tax regulations",
          "row5": "The client pays in their local currency",
          "row6": "Complies with corporate purchasing policies",
          "row7": "Controlled scalability",
          "row8": "Multi-country payment consolidation",
          "row9": "Retain full control over customer relationships",
          "row10": "Retain Control on Profits",
          "row11": "Robust corporate presence from day one",
          "row12": "Risk-free setup cost",
          "row13": "Immediate activation"
        }
      }
    },
    "benchmarking": {
      "title": "Your benchmarking scenarios",
      "description": "Compare the financial impact of each model"
    }
  }
}